import axios from 'axios';

export default {
    install: (app, options = {}) => {
        const token = localStorage.getItem('token') || sessionStorage.getItem('token') || options.token || '';
        
        const axiosInstance = axios.create({
            baseURL: options.baseUrl || process.env.VUE_APP_API_BASE_URL,
            headers: {
                Authorization: token ? `Bearer ${token}` : '',
            }
        });

        // Allow updating token dynamically
        axiosInstance.setAuthToken = (token) => {
            axiosInstance.defaults.headers.Authorization = token ? `Bearer ${token}` : '';
        };

        app.provide('$axios', axiosInstance);
        app.config.globalProperties.$axios = axiosInstance;
    }
};
